import MaskTable from './maskTable';
export default MaskTable;